<template>
  <div class="team-list">
    <!-- {{ cellIndexClicked }} -->
    <RemoveTeamModal
      :showFooter="true"
      :modalName="removeTeamModalName"
      v-show="isModalActive"
      buttonLabel="Delete"
      @confirmAction="confirmRemove($event)"
      colorVariation="secondary"
    >
      <template slot="header">
        <h4 class="editorial">{{ getRemoveHeader }}</h4>
      </template>
      <template slot="body">
        <p class="remove-text">{{ getRemoveDescription }}</p>
      </template>
    </RemoveTeamModal>

    <vue-good-table
      :columns="columns"
      :rows="teamList"
      styleClass="vgt-table striped"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 50,
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page',
        allLabel: 'All'
      }"
      @on-cell-click="onCellClick"
    >
      <div class="vgt-center-align vgt-text-disabled" slot="emptystate">
        There are no items to display
      </div>
      <template slot="table-row" slot-scope="teamList">
        <div v-if="teamList.column.field === 'name'" class="team-name">
          <div v-if="cellIndexClicked[teamList.row.originalIndex]">
            <form @submit.prevent>
              <div class="form-group">
                <input
                  placeholder="Team name..."
                  v-model="
                    cellIndexClicked[teamList.row.originalIndex].editedName
                  "
                />
              </div>
            </form>
          </div>
          <span v-else>{{ teamList.row.name }}</span>
        </div>

        <div v-else-if="teamList.column.field === 'members'">
          <div v-if="cellIndexClicked[teamList.row.originalIndex]">
            <ul class="team-user-list">
              <li v-for="user in teamList.row.users" :key="user.id">
                <span> {{ user.fullName }}</span>
                <span
                  class="remove-user"
                  @click="
                    removeUserFromTeam(
                      user.id,
                      `${user.first_name} ${user.last_name}`,
                      teamList.row.id,
                      teamList.row.name
                    )
                  "
                  >X</span
                >
              </li>
            </ul>
          </div>
          <span v-else>{{
            teamList.row.users.length ? teamList.row.users.length : 0
          }}</span>
        </div>

        <div v-else-if="teamList.column.field === 'action'">
          <div v-if="cellIndexClicked[teamList.row.originalIndex]">
            <div class="team-edit-actions">
              <span class="cancel" @click.stop="cancelEdition(teamList.row)"
                >Cancel</span
              >

              <button class="button-gemnote button-gemnote--tiny">
                <span @click.stop="saveEdition(teamList.row.originalIndex)"
                  >Save</span
                >
              </button>
            </div>
          </div>
          <div v-else class="tpeam-edit">
            <div class="table-edit-options">
              <span>Edit</span>
              <span class="delete" @click.stop="removeTeam(teamList.row)"
                >x</span
              >
            </div>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'TeamList',
  components: {
    VueGoodTable,
    RemoveTeamModal: () => import('@/components/Universal/RemoveModal')
  },
  props: {
    teamList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      removeTeamModalName: 'removeTeamModal',
      cellIndexClicked: new Array(this.teamList.length),
      teamToRemove: {},
      userToRemove: {},
      columns: [
        {
          label: 'Name',
          field: 'name',
          sortable: false,
          width: '30%'
        },
        {
          label: 'Members',
          field: 'members',
          sortable: false,
          width: '30%'
        },
        {
          label: 'Edit',
          field: 'action',
          sortable: false,
          width: '100px'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      activeModals: 'modal/activeModals'
    }),
    isModalActive() {
      return this.activeModals(this.removeTeamModalName)
    },
    getRemoveHeader() {
      if (Object.keys(this.teamToRemove).length) {
        return 'Delete Team'
      }

      return 'Remove user'
    },
    getRemoveDescription() {
      if (Object.keys(this.teamToRemove).length) {
        return `You are about to delete ${this.teamToRemove.name} from Teams.
      Deleting a team removes all users in that team.`
      }
      return `You are about to delete ${this.userToRemove.name} from ${this.userToRemove.teamName}.`
    }
  },
  methods: {
    onCellClick({ column, row }) {
      switch (column.field) {
        case 'action':
          if (!this.cellIndexClicked[row.originalIndex]) {
            let rowToEdit = {
              ...row,
              editedName: row.name
            }
            this.cellIndexClicked.splice(row.originalIndex, 1, rowToEdit)
          }
          break
      }
    },
    saveEdition(rowIndex) {
      this.$store.dispatch('subTeams/editSubTeam', {
        id: this.cellIndexClicked[rowIndex].id,
        name: this.cellIndexClicked[rowIndex].editedName
      })
      this.cellIndexClicked.splice(rowIndex, 1, null)
    },
    cancelEdition(row) {
      this.cellIndexClicked.splice(row.originalIndex, 1, null)
    },
    removeTeam(row) {
      this.userToRemove = {}
      this.teamToRemove = { ...row }
      this.$store.dispatch('modal/showRemoveModal', this.removeTeamModalName)
    },
    confirmRemove() {
      if (Object.keys(this.teamToRemove).length) {
        this.$store.dispatch('subTeams/removeSubTeam', this.teamToRemove.id)
        this.cellIndexClicked.splice(this.teamToRemove.originalIndex, 1, null)
        this.teamToRemove = {}
      } else {
        this.$store.dispatch('subTeams/removeUserFromSubTeam', {
          userId: this.userToRemove.userId
        })
        this.userToRemove = {}
      }
    },
    removeUserFromTeam(userId, name, subTeamId, teamName) {
      this.userToRemove = { userId, name, subTeamId, teamName }
      this.teamToRemove = {}
      this.$store.dispatch('modal/showRemoveModal', this.removeTeamModalName)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../global.scss';
h4 {
  font-size: 2rem;
  font-weight: normal;
}

.table-edit-options {
  .delete {
    font-size: 0.813rem;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    color: $onyx;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.team-list {
  padding-top: 2rem;
}

.team-name {
  form {
    max-width: 70%;
  }
}

.team-user-list {
  list-style-type: none;
  display: table;
  flex-direction: column;
  text-align: left;
  margin: 0;
  text-decoration: none;

  li {
    font-size: $body-base;
    line-height: $body-lineheight-base;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 5px;

    span {
      font-weight: 600;
      font-size: 12px;
      cursor: pointer;
      padding-left: 20px;
    }
  }
}

.team-edit {
  text-align: right;
  font-weight: 600;
  padding-right: 2rem;
  cursor: pointer;
}

.remove-text {
  font-family: $inter;
  margin: 1rem 0rem 3rem 0rem;
  word-break: break-all;
  white-space: pre-line;
}

.vgt-text-disabled {
  color: #24292c;
  padding: 10px;
}

.team-edit-actions {
  display: flex;
  display: flex;
  margin-left: auto;
  align-items: center;

  .cancel {
    border-radius: 40px 0 0 40px;
    border: 1px solid $onyx;
    padding: 0.25rem 0.5rem;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.625rem;
    cursor: pointer;
    height: 24px;
    font-weight: normal;
  }

  .button-gemnote--tiny {
    border-radius: 0 40px 40px 0;
    font-size: 0.625rem;
    padding: 0.25rem 0.75rem;
    width: auto;
    height: 24px;
    font-weight: normal;
  }
}
</style>
